import {
  LDC_BUYER,
  COFCO_BUYER,
  CARGILL_BUYER,
  VITERRA_BUYER,
  BUNGE_BUYER,
  ADM_BUYER,
  MOLINOS_AGROS_BUYER,
  AMAGGI_BUYER,
  CHS_BUYER,
  GEAR_BUYER,
  placeOfDeliveryLDC_TRIGO,
  placeOfDeliveryLDC_MAIZ,
  placeOfDeliveryLDC_CEBADA_FORRAJERA,
  placeOfDeliveryCOFCO_SOJA,
  placeOfDeliveryCOFCO_SORGO,
  placeOfDeliveryCOFCO_CEBADA_FORRAJERA,
  placeOfDeliveryCOFCO_GIRASOL,
  placeOfDeliveryCARGILL_MAIZ,
  placeOfDeliveryCARGILL_SORGO,
  placeOfDeliveryCARGILL_GIRASOL,
  placeOfDeliveryCARGILL_CEBADA_CERVECERA,
  placeOfDeliveryVITERRA_MAIZ,
  placeOfDeliveryVITERRA_SORGO,
  placeOfDeliveryVITERRA_CEBADA_FORRAJERA,
  placeOfDeliveryVITERRA_GIRASOL,
  placeOfDeliveryBUNGE_SOJA,
  placeOfDeliveryBUNGE_TRIGO,
  placeOfDeliveryBUNGE_MAIZ,
  placeOfDeliveryBUNGE_SORGO,
  placeOfDeliveryBUNGE_CEBADA_FORRAJERA,
  placeOfDeliveryBUNGE_GIRASOL,
  placeOfDeliveryADM_SORGO,
  placeOfDeliveryADM_CEBADA_CERVECERA,
  placeOfDeliveryMOLINOS_AGROS_MAIZ,
  placeOfDeliveryAMAGGI_SORGO,
  placeOfDeliveryAMAGGI_CEBADA,
  placeOfDeliveryCHS_SOJA,
  placeOfDeliveryCHS_TRIGO,
  placeOfDeliveryCHS_MAIZ,
  placeOfDeliveryGEAR_TRIGO,
  placeOfDeliveryGEAR_MAIZ,
  placeOfDeliveryGEAR_SORGO,
  placeOfDeliveryLDC_SOJA_CAMARA,
  placeOfDeliveryLDC_SOJA_FABRICA,
  placeOfDeliveryCOFCO_TRIGO_97_5,
  placeOfDeliveryCOFCO_TRIGO_95,
  placeOfDeliveryCOFCO_MAIZ_97_5,
  placeOfDeliveryCOFCO_MAIZ_95,
  placeOfDeliveryCARGILL_SOJA_FABRICA,
  placeOfDeliveryCARGILL_SOJA_CAMARA,
  placeOfDeliveryCARGILL_TRIGO_CAMARA,
  placeOfDeliveryCARGILL_CEBADA_FORRAJERA_97_5,
  placeOfDeliveryCARGILL_CEBADA_FORRAJERA_90,
  placeOfDeliveryVITERRA_SOJA_FABRICA,
  placeOfDeliveryVITERRA_SOJA_CAMARA,
  placeOfDeliveryVITERRA_TRIGO_97_5,
  placeOfDeliveryVITERRA_TRIGO_95,
  placeOfDeliveryADM_SOJA_TRIGO_MAIZ,
  placeOfDeliveryMOLINOS_AGROS_SOJA_TRIGO_GIRASOL,
  placeOfDeliveryAMAGGI_SOJA_TRIGO,
  placeOfDeliveryCARGILL_TRIGO_GRADO_2_95_0,
  placeOfDeliveryCARGILL_TRIGO_GRADO_2_97_5,
} from '@shared-logic/subjects';
import { HOW_SELL_CONST } from './constants/how-sell';
import {
  PLACE_OF_DELIVERY_CONST,
  PLACE_OF_DELIVERY_IBM_CONST,
  PROVINCES_CONST,
  PlaceOfDelivery,
  getPlaceOfDeliveryIBM
} from '@shared-logic/locations';
import { PRODUCT_NAMES_CONST } from '@shared-logic/products';
import { QUALITIES } from '@shared-logic/qualities';
import { RucaAndSisa } from '@shared-logic/integration-ibm';
import { Order } from '@shared-logic/orders';
import { sellerByBuyerCode } from './constants/seller-buyer-map';
// Se basa en la imagen guardada en la siguiente dirección:
// https://drive.google.com/drive/u/0/folders/1do0E5iXNjz26eHSBMczRQZFvM6CZGwUf

//Dada una orden, toma su provincia y valida si Commodities puede comprar en esa provincia.
export function canYouBuyCommodities(order: Order) {
  const numberOfProvince = order.placeOfOrigin.province;
  return canBuyCommoditiesInProvince(numberOfProvince);
}

//Dada una orden, toma su provincia y valida si Hughes puede comprar en esa provincia.
export function canYouBuyHughes(order: Order) {
  const numberOfProvince = order.placeOfOrigin.province;
  return canBuyHughesInProvince(numberOfProvince);
}

//Dada una provincia, verifica si Commodities puede comprar en esa provincia.
export function canBuyCommoditiesInProvince(province: number) {
  return [
    PROVINCES_CONST.BUENOS_AIRES,
    PROVINCES_CONST.CABA,
    PROVINCES_CONST.CORDOBA,
    PROVINCES_CONST.CHACO,
    PROVINCES_CONST.ENTRE_RIOS,
    PROVINCES_CONST.LA_PAMPA,
    PROVINCES_CONST.SAN_LUIS,
    PROVINCES_CONST.SANTA_FE,
    PROVINCES_CONST.SANTIAGO_DEL_ESTERO,
    PROVINCES_CONST.TUCUMAN,
  ].includes(province);
}

//Dada una provincia, verifica si Hughes puede comprar en esa provincia.
export function canBuyHughesInProvince(province: number) {
  return [PROVINCES_CONST.SANTA_FE, PROVINCES_CONST.SALTA, PROVINCES_CONST.FORMOSA].includes(province);
}

export function buyerIsExchanger(buyer: number) {
  return getSellerCodeByBuyerCode(buyer);
}

export function getSellerCodeByBuyerCode(codeB: number): number {
  return sellerByBuyerCode[String(codeB)] ?? 0;
}

// ----------------- PROFORMS BUYERS ------------------\\
// Se basa en la tabla guardada en la siguiente dirección:
// https://docs.google.com/spreadsheets/d/1bs4KU_b9J9xEyJLv3XtRM9zJtD-Yx_9Vt1s0iVPfsq4/edit#gid=1422997573
// ACTUALIZACION: https://docs.google.com/spreadsheets/d/14fMCpXOzIWbWpMO4DEU3iKNq1cd88YhQZvYTa7xwkKs/edit#gid=0
export function isValidOrderByBuyer(
  order: Order,
  buyer: number
): StructBuyerProform | null {
  if (order) {
    switch (buyer) {
      case LDC_BUYER:
        return isValidOrderByLDC(order);
      case COFCO_BUYER:
        return isValidOrderByCofco(order);
      case CARGILL_BUYER:
        return isValidOrderByCargill(order);
      case VITERRA_BUYER:
        return isValidOrderByViterra(order);
      case BUNGE_BUYER:
        return isValidOrderByBunge(order);
      case ADM_BUYER:
        return isValidOrderByADM(order);
      case MOLINOS_AGROS_BUYER:
        return isValidOrderByMolinosAgros(order);
      case AMAGGI_BUYER:
        return isValidOrderByAmaggi(order);
      case CHS_BUYER:
        return isValidOrderByCHS(order);
      case GEAR_BUYER:
        return isValidOrderByGear(order);
      //case INGREDION_ARGENTINA_BUYER: return isValidOrderByIngredionArgentina(order);
    }
  }
  return null;
}

interface FieldBuyerProform {
  isValid: boolean;
  default: number;
  arrayValids: number[];
}

export interface StructBuyerProform {
  product: FieldBuyerProform;
  quality: FieldBuyerProform;
  place: FieldBuyerProform;
  wayPay: FieldBuyerProform;
}

interface DataCondition {
  productName: number;
  place: PlaceOfDelivery;
  placeOfDeliveryIBM: number;//Al final solo un lugar de entrega. 
  // //Toda la lista de lugares de entrega de la condición. Si es especifico, solo uno.

  quality: number;
  percentageWayPay: number;
}

interface Conditions {
  productName: number;
  placeOfDelivery: number[];
  quality: number;
  percentageWayPay: number;
  deliveryDefaultInSantaFe?: number;
  deliveryDefaultInBuenosAires?: number;
}

const fieldVoid: FieldBuyerProform = {
  isValid: false,
  default: 0,
  arrayValids: [],
};

const structVoid: StructBuyerProform = {
  product: fieldVoid,
  place: fieldVoid,
  quality: fieldVoid,
  wayPay: fieldVoid,
};

function getCondition(order: Order): DataCondition {
  return {
    percentageWayPay: order.price.wayPay.percentage,
    placeOfDeliveryIBM: getPlaceOfDeliveryIBM(order),
    place: order.price.placeOfDelivery,
    productName: order.price.productName,
    quality: order.price.quality,
  };
}

/**
 * Given two arrays with numbers, it compares whether any element of the second exists in the first array and returns it.
 * @param array1
 * @param array2
 * @returns number
 */
function getCommonElement(array1: number[], array2: number[]): number {
  let valueToReturn: number = 0;
  for (let i = 0; i < array1.length; i++) {
    if (array2.includes(array1[i])) {
      valueToReturn = array1[i];
      break;
    }
  }
  return valueToReturn;
}

/**
 * Given a DataCondition, and an array of placeOfDelivery.
 * Compare the data information and find the closest element for the placeOfDelivery.
 * @param data
 * @param placeOfDeliveries
 * @returns placeOfDelivery:number
 */
function getPlaceOfDeliveryDefault(
  data: DataCondition,
  placeOfDeliveries: number[]
): number {
  const arrayToSearch: number[] = getArrayOfPortsIBMByZona(data.place.zone);

  const place = getCommonElement(placeOfDeliveries, arrayToSearch);

  //TODO: acá podría agregarse la lógica para seleccionar el default de Buenos Aires y de Santa Fe.
  return place ? place : placeOfDeliveries[0];
}

/**
 * The ports that a zone has are obtained. Each port has the IBM code.
 * https://docs.google.com/spreadsheets/d/14fMCpXOzIWbWpMO4DEU3iKNq1cd88YhQZvYTa7xwkKs/edit#gid=1127956965
 * @param zone:number
 * @returns port: number[]
 */
function getArrayOfPortsIBMByZona(zone: number): number[] {
  if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE) {
    //TODO: Agregar PLACE_OF_DELIVERY_IBM_CONST.RICARDONE el día que algún comprador lo utilice.
    return [
      PLACE_OF_DELIVERY_IBM_CONST.SAN_LORENZO,
      PLACE_OF_DELIVERY_IBM_CONST.SAN_MARTIN,
      PLACE_OF_DELIVERY_IBM_CONST.TIMBUES,
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO_SUR) {
    return [
      PLACE_OF_DELIVERY_IBM_CONST.GENERAL_LAGOS,
      PLACE_OF_DELIVERY_IBM_CONST.ARROYO_SECO,
      PLACE_OF_DELIVERY_IBM_CONST.PUNTA_ALVEAR,
      PLACE_OF_DELIVERY_IBM_CONST.VILLA_CONSTITUCION,
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO) {
    return [PLACE_OF_DELIVERY_IBM_CONST.ROSARIO];
  } else if (zone == PLACE_OF_DELIVERY_CONST.UP_RIVER) {
    return [
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE),
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_SUR),
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO),
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE_Y_SUR) {
    return [
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE),
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_SUR),
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE_Y_ROSARIO) {
    return [
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_NORTE),
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO),
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.ROSARIO_SUR_Y_ROSARIO) {
    return [
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO_SUR),
      ...getArrayOfPortsIBMByZona(PLACE_OF_DELIVERY_CONST.ROSARIO),
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.PUERTOS_BUENOS_AIRES) {
    return [
      PLACE_OF_DELIVERY_IBM_CONST.BAHIA_BLANCA,
      PLACE_OF_DELIVERY_IBM_CONST.NECOCHEA,
      PLACE_OF_DELIVERY_IBM_CONST.LIMA,
      PLACE_OF_DELIVERY_IBM_CONST.TERM_LAS_PALMAS,
      PLACE_OF_DELIVERY_IBM_CONST.RAMALLO,
      PLACE_OF_DELIVERY_IBM_CONST.JUNIN,
    ];
  } else if (zone == PLACE_OF_DELIVERY_CONST.PUERTOS_ENTRE_RIOS) {
    return [
      PLACE_OF_DELIVERY_IBM_CONST.TERMINAL_Pto_DEL_GUAZU,
      PLACE_OF_DELIVERY_IBM_CONST.DIAMANTE,
    ];
  }
  //Plantas interior abarca todo
  return [];
}

function validateCondition(
  data: DataCondition,
  productName: number,
  quality: number,
  placeOfDeliveries: number[],
  percentageWayPay: number
): StructBuyerProform {
  let struct: StructBuyerProform = createEmptyStruct();
  if (data.productName == productName) {
    struct.product.isValid = true;
    struct.product.arrayValids = [productName];
    struct.product.default = productName;

    //En este punto, 
    const hasPlaceIBM = data.placeOfDeliveryIBM > 0; //Si existe alguna placeOfDeliveryIBM, entonces es true.
    if (hasPlaceIBM) {
      //Nos fijamos si existe
      struct.place.isValid = placeOfDeliveries.includes(data.placeOfDeliveryIBM);
      struct.place.arrayValids = placeOfDeliveries;
      struct.place.default = struct.place.isValid ? data.placeOfDeliveryIBM : getPlaceOfDeliveryDefault(data, placeOfDeliveries);
    } else {
      //Ingresó una zona en vez de puerto específico.
      //Entonces buscamos un puerto especifico que mejor se adapte.
      const ports = getArrayOfPortsIBMByZona(data.place.zone);
      const portDefault = getCommonNumber(ports, placeOfDeliveries);
      struct.place.isValid = portDefault != null;
      struct.place.arrayValids = placeOfDeliveries;
      struct.place.default = struct.place.isValid ? portDefault! : getPlaceOfDeliveryDefault(data, placeOfDeliveries);
    }


    struct.quality.isValid = data.quality == quality || quality == 0;
    struct.quality.arrayValids = [quality];
    struct.quality.default = quality;

    struct.wayPay.isValid =
      data.percentageWayPay == percentageWayPay || percentageWayPay == 0;
    struct.wayPay.arrayValids = [percentageWayPay];
    struct.wayPay.default = percentageWayPay;
  }

  return struct;
}

function hasCommonNumber(arr1: number[], arr2: number[]): boolean {
  return arr1.some(num => arr2.includes(num));
}

function getCommonNumber(arr1: number[], arr2: number[]): number | null {
  for (const n of arr1) {
    if (arr2.includes(n)) return n;
  }
  return null;
}

/**
 * Given an array of Conditions and a productName,
 * it returns an array with all the indexes where that productName has that productName.
 * @params conditions: Conditions[]
 * @params productName: number
 * @returns number[]
 */
/*function getIndexesByProductName(
  conditions: Conditions[],
  productName: number
): number[] {
  let indexes: number[] = [];
  for (let i = 0; i < conditions.length; i++) {
    if (conditions[i].productName == productName) {
      indexes.push(i);
    }
  }
  return indexes;
}*/

/**
 * Given a StructBuyerProform, it returns the number of isValid fields it has.
 * @params struct: StructBuyerProform
 * @returns number
 */
/*function getNumberOfValids(struct: StructBuyerProform): number {
  let number: number = 0;
  if (struct.product.isValid) number++;
  if (struct.quality.isValid) number++;
  if (struct.place.isValid) number++;
  if (struct.wayPay.isValid) number++;
  return number;
}*/

function createEmptyField(): FieldBuyerProform {
  return { isValid: false, default: 0, arrayValids: [] };
}

function createEmptyStruct(): StructBuyerProform {
  return {
    product: createEmptyField(),
    place: createEmptyField(),
    quality: createEmptyField(),
    wayPay: createEmptyField(),
  };
}

/**
 * Compares 2 StructBuyerProforms, returns the one with the most valid fields.
 * @params struct1: StructBuyerProform
 * @params struct2: StructBuyerProform
 * @returns StructBuyerProform
 */
function compareStructs(a: StructBuyerProform, b: StructBuyerProform) {
  if (a.place.isValid !== b.place.isValid) return a.place.isValid ? a : b;
  if (a.quality.isValid !== b.quality.isValid) return a.quality.isValid ? a : b;
  if (a.wayPay.isValid !== b.wayPay.isValid) return a.wayPay.isValid ? a : b;
  return a;
}

/**
 * Given the information of an order and an arrangement of preloaded conditions.
 * Returns a structure specifying what was the best preloaded condition for that case.
 * We always assume that the product from the user's order is correctly loaded. Therefore,
 * we analyze how many conditions are preloaded with that product.
 * If it is one, there will be no problem. It will end up analyzing that one alone.
 * If there is more than one, we must take the best one. We must take the one that has the most valid fields.
 *
 * Actualización mayo 2025:
 * 1. Primero elige quién acierta el lugar.
 * 2. Si siguen empatados, evalúa la calidad.
 * 3. Finalmente la forma de pago.
 * 4. Se rompe el bucle si ya encontró coincidencia plena (place+quality+wayPay).
 * @params data: DataCondition
 * @params conditions: Conditions[]
 * @returns StructBuyerProform
 */
function getStructByConditions(
  data: DataCondition,
  conditions: Conditions[]
): StructBuyerProform {
  const matches = conditions.filter((c) => c.productName === data.productName);
  let best = createEmptyStruct();
  for (const c of matches) {
    const cand = validateCondition(
      data,
      c.productName,
      c.quality,
      c.placeOfDelivery,
      c.percentageWayPay
    );

    best = compareStructs(best, cand);
    // Si ya es “perfecto” (lugar, calidad y forma de pago válidos), cortamos
    if (best.place.isValid && best.quality.isValid && best.wayPay.isValid) {
      break;
    }
  }
  console.log("BEST: ", best);
  return best;
}
function isValidOrderByLDC(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryLDC_SOJA_CAMARA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryLDC_SOJA_FABRICA,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryLDC_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // No requiere actualización, ya usan 95%
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryLDC_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryLDC_CEBADA_FORRAJERA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 95,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByCofco(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryCOFCO_SOJA,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCOFCO_TRIGO_97_5,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // Actualizado el 26 de noviembre de 2025
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCOFCO_TRIGO_95,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryCOFCO_MAIZ_97_5,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryCOFCO_MAIZ_95,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryCOFCO_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.GIRASOL,
      placeOfDelivery: placeOfDeliveryCOFCO_GIRASOL,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryCOFCO_CEBADA_FORRAJERA,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByCargill(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryCARGILL_SOJA_FABRICA,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryCARGILL_SOJA_CAMARA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCARGILL_TRIGO_GRADO_2_97_5,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCARGILL_TRIGO_CAMARA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCARGILL_TRIGO_GRADO_2_95_0,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryCARGILL_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.GIRASOL,
      placeOfDelivery: placeOfDeliveryCARGILL_GIRASOL,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryCARGILL_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryCARGILL_CEBADA_FORRAJERA_97_5,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryCARGILL_CEBADA_FORRAJERA_90,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 90,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_CERVECERA,
      placeOfDelivery: placeOfDeliveryCARGILL_CEBADA_CERVECERA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 90,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByViterra(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryVITERRA_SOJA_FABRICA,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryVITERRA_SOJA_CAMARA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryVITERRA_TRIGO_97_5,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryVITERRA_TRIGO_95,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryVITERRA_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.GIRASOL,
      placeOfDelivery: placeOfDeliveryVITERRA_GIRASOL,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryVITERRA_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryVITERRA_CEBADA_FORRAJERA,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
  ];
  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByBunge(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryBUNGE_SOJA,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryBUNGE_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // Actualizado el 26 de noviembre de 2025
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryBUNGE_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryBUNGE_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.GIRASOL,
      placeOfDelivery: placeOfDeliveryBUNGE_GIRASOL,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_FORRAJERA,
      placeOfDelivery: placeOfDeliveryBUNGE_CEBADA_FORRAJERA,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByADM(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryADM_SOJA_TRIGO_MAIZ,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryADM_SOJA_TRIGO_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // No requiere actualización, ya usan 95%
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryADM_SOJA_TRIGO_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryADM_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_CERVECERA,
      placeOfDelivery: placeOfDeliveryADM_CEBADA_CERVECERA,
      quality: 0,
      percentageWayPay: 90,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByMolinosAgros(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryMOLINOS_AGROS_SOJA_TRIGO_GIRASOL,
      quality: QUALITIES.FABRICA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryMOLINOS_AGROS_SOJA_TRIGO_GIRASOL,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // Actualizado el 26 de noviembre de 2025
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryMOLINOS_AGROS_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.GIRASOL,
      placeOfDelivery: placeOfDeliveryMOLINOS_AGROS_SOJA_TRIGO_GIRASOL,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByAmaggi(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryAMAGGI_SOJA_TRIGO,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryAMAGGI_SOJA_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95, // Actualizado el 26 de noviembre de 2025
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryAMAGGI_SOJA_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryAMAGGI_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.CEBADA_CERVECERA,
      placeOfDelivery: placeOfDeliveryAMAGGI_CEBADA,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 95,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByCHS(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.SOJA,
      placeOfDelivery: placeOfDeliveryCHS_SOJA,
      quality: QUALITIES.CAMARA,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryCHS_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryCHS_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

function isValidOrderByGear(order: Order) {
  const conditions: Conditions[] = [
    {
      productName: PRODUCT_NAMES_CONST.TRIGO,
      placeOfDelivery: placeOfDeliveryGEAR_TRIGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.MAIZ,
      placeOfDelivery: placeOfDeliveryGEAR_MAIZ,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
    {
      productName: PRODUCT_NAMES_CONST.SORGO,
      placeOfDelivery: placeOfDeliveryGEAR_SORGO,
      quality: QUALITIES.GRADO_2,
      percentageWayPay: 97.5,
    },
  ];

  return getStructByConditions(getCondition(order), conditions);
}

/*function isValidOrderByIngredionArgentina(order:Order){
    const conditions:Conditions[]=[
        { productName: PRODUCT_NAMES_CONST.MAIZ, placeOfDelivery: placeOfDeliveryINGREDION_ARGENTINA_MAIZ, quality: QUALITIES.GRADO_2, percentageWayPay: 100 }
    ];
    
    return getStructByConditions(getCondition(order), conditions);
}*/

// -------------- HOW SELL ----------------\\
/**
 * Valida si el vendedor está habilitado para operar según la modalidad de venta.
 * Distribuye la validación a la función correspondiente según el tipo: Acopio, Producción Propia, Consignación o Cooperativa.
 * @param howSell
 * @param validationRucaSisa
 * @param sellerCode
 */
export function itCanBeHowSell(
  howSell: number,
  validationRucaSisa: RucaAndSisa,
  sellerCode: number
) {
  switch (howSell) {
    case HOW_SELL_CONST.ACOPIO:
      return itCanBeAcopioSeller(howSell, validationRucaSisa, sellerCode);
    case HOW_SELL_CONST.PRODUCCION_PROPIA:
      return itCanBeProduccionPropiaSeller(howSell, validationRucaSisa, sellerCode);
    case HOW_SELL_CONST.CONSIGNACION:
      return itCanBeConsignacionSeller(howSell, validationRucaSisa, sellerCode);
    case HOW_SELL_CONST.COOPERATIVA:
      return itCanBeCooperativaSeller(howSell, validationRucaSisa, sellerCode);
    default:
      return false;
  }
}


/**
 * Valida si puede operar como Acopio.
 * Reglas de validación:
 * 1. Debe existir en RUCA.
 * 2. Debe existir en SISA.
 * 3. El estado en SISA debe estar activo (diferente de 0).
 *
 * Feature temporal: Se permite saltar la validación del SISA para ciertos códigos de vendedores (nuevos clientes).
 */
export function itCanBeAcopioSeller(
  howSell: number,
  validationRucaSisa: RucaAndSisa,
  sellerCode: number
) {
  // BIPUCRE
  if ([90094].includes(sellerCode)) {
    return true;
  }

  if (howSell == HOW_SELL_CONST.ACOPIO) {
    if (validationRucaSisa.ExisteRuca == 'N') {
      return false;
    } else if (validationRucaSisa.ExisteSisa == 'N') {
      return false;
    } else if (validationRucaSisa['Estado SISA'] == 0) {
      return false;
    }
    return true;
  }
  return false;
}


/**
 * Valida si puede operar como Producción Propia.
 * Reglas de validación:
 * 1. Debe existir en SISA.
 * 2. El estado en SISA debe estar activo (diferente de 0).
 * NOTA: No valida RUCA para este caso.
 */
export function itCanBeProduccionPropiaSeller(
  howSell: number,
  validationRucaSisa: RucaAndSisa,
  sellerCode: number
) {
  if (howSell == HOW_SELL_CONST.PRODUCCION_PROPIA) {
    if (validationRucaSisa.ExisteSisa == 'N') {
      return false;
    } else if (validationRucaSisa['Estado SISA'] == 0) {
      return false;
    }
    return true;
  }
  return false;
}


/**
 * Valida si puede operar como Consignación.
 * Reglas de validación:
 * 1. Debe existir en RUCA.
 * 2. Debe existir en SISA.
 * 3. El estado en SISA debe estar activo (diferente de 0).
 *
 * Feature temporal: Se permite saltar la validación del SISA para ciertos códigos de vendedores (nuevos clientes).
 */
export function itCanBeConsignacionSeller(
  howSell: number,
  validationRucaSisa: RucaAndSisa,
  sellerCode: number
) {
  // RA CEREALES, BIPUCRE
  if ([7835, 90094].includes(sellerCode)) {
    return true;
  }

  if (howSell == HOW_SELL_CONST.CONSIGNACION) {
    if (validationRucaSisa.ExisteRuca == 'N') {
      return false;
    } else if (validationRucaSisa.ExisteSisa == 'N') {
      return false;
    } else if (validationRucaSisa['Estado SISA'] == 0) {
      return false;
    }
    return true;
  }
  return false;
}


/**
 * Valida si puede operar como Cooperativa.
 * Reglas de validación:
 * 1. Debe existir en RUCA.
 * 2. Debe existir en SISA.
 * 3. El estado en SISA debe estar activo (diferente de 0).
 */
export function itCanBeCooperativaSeller(
  howSell: number,
  validationRucaSisa: RucaAndSisa,
  sellerCode: number
) {
  if (howSell == HOW_SELL_CONST.COOPERATIVA) {
    if (validationRucaSisa.ExisteRuca == 'N') {
      return false;
    } else if (validationRucaSisa.ExisteSisa == 'N') {
      return false;
    } else if (validationRucaSisa['Estado SISA'] == 0) {
      return false;
    }
    return true;
  }
  return false;
}
